import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import './CartItems.css';

const CartItems = ({ cake, removeFromCart }) => {
    const { name, id,img } = cake;
    return (
        <li className='cart-items'>
            <div className='cake-info'>
            <img className='cake-info-img' src={img} alt="" />
            <p>{name}</p>
            </div>
            <button 
            className='delete-btn'
            onClick={() => removeFromCart(id)}
            ><DeleteIcon
            /></button>
        </li>
    );
};

export default CartItems;